import "./App.css";
import React, { useState, createContext } from "react";
import AuthRoutes from "./routes/AuthRoutes";
import DashRoutes from "./routes/DashRoutes";
import "bootstrap/dist/css/bootstrap.min.css";

export const context = createContext();

function App() {
  const [signIn, setSignIn] = useState(false);

  return (
    <context.Provider value={[signIn, setSignIn]}>
      {signIn ? <DashRoutes /> : <AuthRoutes />}
    </context.Provider>
  );
}
export default App;
